module.exports = __webpack_public_path__ + "58998499f5da07b6194317c8152d25c0.svg";